import { apiFetch } from '#imports'
import type { actionResponse } from '~/layers/cms/app/types/cmsTypes'

export const getReviews = async (): Promise<actionResponse> => {
  const options = {
    method: 'GET'
  }

  const url = `/get-reviews`

  return apiFetch(url, options)
}
